module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMUlEQVQ4T62TsUoDQRCG/3/OU1HSiIWNaKPXCIJN2oAvIEEDIkg6bfQBfAAfwEqriCCCgvgCgm0aIWBzSROxsRCboGjOm5E9chCDSvSy3ezs/+38uzNEzzoK1yeHJVqA6SyAXCfdAqXZVv9uKzh76pYwDc5tzXutRwUDF3uhXwVWG5v3b0q8iN1+AnDil/CjCGI62RTLC5A3YKpz6FGBqimrCczwMB4MXTpIAjgOV5bdzSKWA7kBs7lvqyAbMDtVZYuwWjm4umbiGW+bTiAetn8Up0SyoTEOXdjG6AkrjdUCNF5yZRMo/eY/zZlz7eyId8tKvViG2YQntmvATD8AAvex8gDkswPswMwXsX0AI/0AALyrcg9kNBBARgtZHzHzN2ZupIG0cgr59zB1//1fx/kTOKPKsb9gfNcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/stationTobu/normalStuts.png
// module id = 4759
// module chunks = 0